"use client"

import { CircleCheck } from "lucide-react"

import { getMetaLeadFormReadiness } from "@/lib/meta-ads/form-readiness"
import type { MetaLeadForm } from "@/lib/meta-ads/types"
import { useTranslations } from "next-intl"


export function MetaAdsFormReadinessChoice({
  form,
  phoneFieldKey,
}: {
  form: MetaLeadForm
  phoneFieldKey: string
}) {
  const tUi = useTranslations("Integrations.IntegrationsMetaAdsMetaAdsFormReadinessChoice")

  const readiness = getMetaLeadFormReadiness(form, phoneFieldKey)
  const titleId = `meta-form-choice-${form.id}`

  if (!readiness.configuredPhoneFieldPresent) {
    return (
      <section aria-labelledby={titleId} className="space-y-4 rounded-lg border bg-muted/30 p-5">
        <div className="space-y-2">
          <p className="text-sm text-muted-foreground">{form.name}</p>
          <h3 id={titleId} className="text-pretty text-lg font-semibold">
            <span key={tUi("step1CreateAnUnrestrictedCopy")}>{tUi("step1CreateAnUnrestrictedCopy")}</span></h3>
          <p className="text-sm text-muted-foreground">
            <span key={tUi("thisFormDoesNotContainThePhoneField")}>{tUi("thisFormDoesNotContainThePhoneField")}</span></p>
        </div>
      </section>
    )
  }

  if (readiness.deliveryMode !== "targeted_ads_only") return null

  return (
    <section aria-labelledby={titleId} className="space-y-4 rounded-lg border bg-muted/30 p-5">
      <div className="space-y-2">
        <p className="text-sm text-muted-foreground">{form.name}</p>
        <p className="flex items-center gap-2 text-sm font-medium text-emerald-700">
          <CircleCheck aria-hidden="true" className="h-4 w-4" />
          <span><span key={tUi("liveAdLeadsAlreadyWork")}>{tUi("liveAdLeadsAlreadyWork")}</span></span>
        </p>
        <h3 id={titleId} className="text-pretty text-lg font-semibold">
          <span key={tUi("step1CreateAnUnrestrictedCopy")}>{tUi("step1CreateAnUnrestrictedCopy")}</span></h3>
        <p className="text-sm text-muted-foreground">
          <span key={tUi("createThisCopySoSubmissionsFromMetaS")}>{tUi("createThisCopySoSubmissionsFromMetaS")}</span></p>
      </div>
    </section>
  )
}
